var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePayBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 40,
    height: 21.2507,
    viewBox: "0 0 40 21.2507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Base_1_",
    d: "M29.3617 0H10.6383C4.78723 0 0 4.78141 0 10.6253C0 16.4693 4.78723 21.2507 10.6383 21.2507H29.3617C35.2128 21.2507 40 16.4693 40 10.6253C40 4.78141 35.2128 0 29.3617 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePayBase);
export default __webpack_public_path__ + "static/media/google-pay-base.2e8a7f667b2421fbbfffef099f88c13c.svg";
export { ForwardRef as ReactComponent };